import { RangeSlider } from '@shopify/polaris';
import React from 'react';

export const RenderRangeSlider = (field) => {
  React.useLayoutEffect(() => {
    if (field.beforeOutput) {
      const styleElem = document.head.appendChild(document.createElement('style'));
      styleElem.innerHTML = `${field.parentClass || ``} .Polaris-RangeSlider-SingleThumb__OutputText:before { content: '${field.beforeOutput}'; }`;
    }
    if (field.afterOutput) {
      const styleElem = document.head.appendChild(document.createElement('style'));
      styleElem.innerHTML = `${field.parentClass || ``} .Polaris-RangeSlider-SingleThumb__OutputText:after { content: '${field.afterOutput}'; }`;
    }
  }, [field.afterOutput, field.beforeOutput, field.parentClass]);

  return (
    <RangeSlider
      value={field.input.value}
      onChange={field.input.onChange}
      suffix='High'
      prefix='Low'
      output
      min={field.min || 0}
      max={field.max || 100}
      step={field.step || 1}
    />
  );
};